import { Head, usePage } from "@inertiajs/react"
import PublicLayout from "@/components/PublicLayout"
import { useLocalePath } from "@/lib/locale-path"
import type { PageProps } from "@/types/inertia"

interface Props {
  status: "confirmed" | "invalid"
}

export default function NewsletterConfirmed({ status }: Props) {
  const { props } = usePage<PageProps>()
  const t = props.translations.newsletter.confirmed
  const lp = useLocalePath()
  const ok = status === "confirmed"

  return (
    <>
      <Head title={t.meta_title}>
        <meta name="description" content={t.meta_description} />
        <meta property="og:title" content={t.meta_title} />
        <meta property="og:description" content={t.meta_description} />
        <meta name="robots" content="noindex" />
      </Head>
      <PublicLayout>
        <section className="bg-cream pt-32 pb-24">
          <div className="mx-auto max-w-2xl px-6 text-center lg:px-8">
            <h1>{ok ? t.heading : t.invalid_heading}</h1>
            <p className="mt-4 text-ink-muted">{ok ? t.body : t.invalid_body}</p>
            <p className="mt-8">
              <a href={lp("/blog")} className="font-medium text-teal-mid hover:text-teal">
                {t.cta}
              </a>
            </p>
          </div>
        </section>
      </PublicLayout>
    </>
  )
}
